import { mapTurnTimeMetrics } from 'app/pages/tpoPortal/commandCenterHome/CommandCenterHome/turnTimeMetrics.utils';
import { turnTimeDefinitionApi } from 'app/services/api';
import { normalize, schema } from 'normalizr';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const TURN_TIME_DEFINITIONS_ACTION_TYPE = createNamedActions('systemTurnTimeDefinitions', {
  GET_TURN_TIME_DEFINITIONS: 'GET_TURN_TIME_DEFINITIONS',
  CREATE_TURN_TIME_DEFINITION: 'CREATE_TURN_TIME_DEFINITION',
  UPDATE_TURN_TIME_DEFINITION: 'UPDATE_TURN_TIME_DEFINITION',
  DELETE_TURN_TIME_DEFINITION: 'DELETE_TURN_TIME_DEFINITION',
  SET_TURN_TIME_METRICS: 'SET_TURN_TIME_METRICS',
});

const turnTimeDefinitionsSchema = new schema.Entity('data', {}, { idAttribute: 'id' });

// Broker-home reads pass this so a 403 (DEV-3647 broker-auth gap) degrades to the
// empty state instead of triggering the global forbidden page-reload loop. The
// admin turn-time page (withPreparedData) dispatches the same reads with route
// params and no skipResponseInterceptor, so its real errors still surface — only
// the skip flag is threaded into the http config, never the prepared-data params.
export const SKIP_FORBIDDEN_TURN_TIME_CONFIG = {
  skipResponseInterceptor: { forbiddenError: true },
};

export const getTurnTimeDefinitionsAction = catchAsyncActionError(
  ({ skipResponseInterceptor } = {}) =>
    async dispatch => {
      const { data: definitions } = await turnTimeDefinitionApi.getTurnTimeDefinitions({
        skipResponseInterceptor,
      });

      return dispatch({
        type: TURN_TIME_DEFINITIONS_ACTION_TYPE.GET_TURN_TIME_DEFINITIONS,
        payload: normalize(definitions, [turnTimeDefinitionsSchema]).entities.data,
      });
    },
);

export const createTurnTimeDefinitionAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await turnTimeDefinitionApi.createTurnTimeDefinition(params);

  return dispatch({
    type: TURN_TIME_DEFINITIONS_ACTION_TYPE.CREATE_TURN_TIME_DEFINITION,
    payload: data,
  });
});

export const updateTurnTimeDefinitionAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await turnTimeDefinitionApi.updateTurnTimeDefinition(params);

  return dispatch({
    type: TURN_TIME_DEFINITIONS_ACTION_TYPE.UPDATE_TURN_TIME_DEFINITION,
    payload: data,
  });
});

export const deleteTurnTimeDefinitionAction = catchAsyncActionError(params => async dispatch => {
  await turnTimeDefinitionApi.deleteTurnTimeDefinition(params);

  return dispatch({
    type: TURN_TIME_DEFINITIONS_ACTION_TYPE.DELETE_TURN_TIME_DEFINITION,
    meta: params,
  });
});

export const getTurnTimeMetricsAction = catchAsyncActionError((params = {}) => async dispatch => {
  const { data } = await turnTimeDefinitionApi.getTurnTimeMetrics(params);

  return dispatch({
    type: TURN_TIME_DEFINITIONS_ACTION_TYPE.SET_TURN_TIME_METRICS,
    payload: mapTurnTimeMetrics(data),
  });
});
